<template>
  <!-- The words of the resume, in the chosen template. Not the sheet itself, so the same body is
       drawn on screen and on the printed page. Each template belongs to a layout family. -->
  <component :is="LAYOUTS[FAMILY[template] || 'single']" :content="content" :template="template" :picture-url="pictureUrl" />
</template>

<script setup>
import SingleColumnLayout from './SingleColumnLayout.vue'
import SidebarLayout from './SidebarLayout.vue'
import LabelLayout from './LabelLayout.vue'
import { FAMILY } from './resumeLayout.js'

defineProps({
  content: { type: Object, required: true },
  template: { type: String, default: 'modern' },
  pictureUrl: { type: String, default: null }, // the resume's picture, if it has one
})

const LAYOUTS = { single: SingleColumnLayout, side: SidebarLayout, label: LabelLayout }
</script>
